import { parse, minutesToMilliseconds } from 'date-fns';
import { DATE_TIME_FORMAT } from './const.ts';

export default function parseTimelineValue(value: number | 'live' | undefined): number {
    if (!value) return 0;
    if (value === 'live') return Date.now();
    return value;
}

export const parseStringTimeValue = (time) => {
    const end = parse(`${time}Z`, DATE_TIME_FORMAT + 'X', new Date());
    return Number(end) + minutesToMilliseconds(new Date().getTimezoneOffset());
};
